
export const BASE_KOBO_SOCIETY_API_URL = process.env.VUE_APP_KOBO_SOCIETY_API

export const BASE_KOBO_MERCHANT_API_URL = process.env.VUE_APP_KOBO_MERCHANT_API

export const BASE_KOBO_PAYMENT_API_URL = process.env.VUE_APP_KOBO_PAYMENT_API
